import { render, staticRenderFns } from "./TableBatchesList.template.vue?vue&type=template&id=04203f37&scoped=true&"
var script = {}
import style0 from "./TableBatchesList.template.vue?vue&type=style&index=0&id=04203f37&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04203f37",
  null
  
)

export default component.exports